import React from "react";

interface Props {
    date: string;
    origin: string;
    message: string;
    ownMessage: boolean;
}

const ChatMessage : React.FC<Props> = ({date, origin, message, ownMessage}) => {
    return (
        <div className={`chatmsg-ctn ${ownMessage ? "chatmsg-right" : "chatmsg-left"}`}>
            {!ownMessage && <span className="chatmsg-origin">{origin}</span>}
            <span className="chatmsg-message">{message}</span>
            <span className="chatmsg-date">{date}</span>
        </div>
    )
}

export default ChatMessage;